module.exports = __webpack_public_path__ + "public/images/generated-learn-japanese.5ee29ca8c7d223531a146bbc756b1939.jpg";